import { Component, Input } from '@angular/core';
import { Show } from '../../../models/Show';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-show-big',
  imports: [CommonModule],
  templateUrl: './show-big.component.html',
  styleUrl: './show-big.component.scss',
})
export class ShowBigComponent {
  @Input() show!: Show;
  // returns true when the show's date is strictly before today (past)
  get isPast(): boolean {
    if (!this.show || !this.show.date) return false;
    const showDate = new Date(this.show.date);
    // Compare by date only (ignore time). Normalize both to midnight local time.
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    showDate.setHours(0, 0, 0, 0);
    return showDate.getTime() < today.getTime();
  }
  formatDate(date: Date): string {
    return date.toLocaleDateString('en-UK', {
      month: 'long',
      day: 'numeric',
    });
  }
}
